import React, { useEffect, useMemo, useState } from "react";
import { Badge, Button, Card, Tag } from "antd";
import {
  CheckCircleOutlined,
  CheckOutlined,
  ExclamationCircleOutlined,
  ToolOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import get from "lodash/get";
import map from "lodash/map";
import { getNotificationRelativeTime } from "../../utilities/notification";

const getNotificationBadge = (type) => {
  switch (type) {
    case "error":
      return <ExclamationCircleOutlined />;
    case "warning":
      return <WarningOutlined />;
    case "processing":
      return <ToolOutlined />;
    case "default":
      return <ExclamationCircleOutlined />;
  }
};

const NotificationCard = ({ notification, acknowledgeNotification }) => {
  const config = get(notification, "notification_type.config");
  
  return (
    <Card
      key={get(notification, "id")}
      size="small"
      hoverable
      bodyStyle={{
        padding: "10px 14px",
      }}
      className={`border-l-4 ${get(config, "border")} transition-all hover:shadow-md`}
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-4 flex-1 min-w-0">
          <Badge status={get(config, "badge")} />
          <div className="w-36 shrink-0">
            <div className="font-medium text-sm truncate">
              {get(notification, "template.name")}
            </div>

            <div className="text-xs text-gray-500">
              {getNotificationRelativeTime(get(notification, "created_at"))}
            </div>
          </div>

          <Tag
            color={get(config, "color")}
            className="m-0 w-44 text-center shrink-0"
            icon={getNotificationBadge(get(config, "badge"))}
          >
            {get(config, "tag")}
          </Tag>

          <div className="flex-1 min-w-0">
            <div className="font-medium text-sm truncate">
              {get(notification, "title")}
            </div>

            <div className="text-xs text-gray-500 truncate">
              {get(notification, "message")}
            </div>
          </div>
        </div>

        <div className="shrink-0">
          {get(notification, "is_readed", false) ? (
            <Button size="small" disabled icon={<CheckCircleOutlined />}>
              Ack
            </Button>
          ) : (
            <Button
              size="small"
              type="primary"
              icon={<CheckOutlined />}
              onClick={() => acknowledgeNotification(get(notification, "id"))}
            >
              Ack
            </Button>
          )}
        </div>
      </div>
    </Card>
  );
};

export default NotificationCard;
